import { RowCell, Skeleton, TableRow } from '@bbl-digital/snorre'
import { useIsMobile } from '@bbl-digital/snorre-v2'
import { FC, Fragment, ReactNode, type JSX } from 'react'
import { listBreakpoint } from 'shared/constants/styles'

interface IProps {
  // Breakpoint for mobile
  breakpoint?: number
  // Number of columns in the table body
  columns?: number
  // Number of loading rows on desktop
  rows?: number
  // Custom row
  customRow?: ReactNode
}

// Component made for <BoxedTable />
const SkeletonTable: FC<IProps> = ({
  customRow,
  columns = 5,
  breakpoint = listBreakpoint,
  rows = 5,
}) => {
  const isMobile = useIsMobile(breakpoint)

  const list: JSX.Element | ReactNode[] = []

  const iterationArr = Array.from(Array(columns).keys())

  const SkeletonCell = () => (
    <RowCell align="unset">
      <Skeleton height="20px" />
    </RowCell>
  )

  const getWidth = (index: number) => {
    if (index === 0) return '70%'
    if ((index + 1) % 3 === 0) return '40%'
    if ((index + 1) % 5 === 0) return '60%'
    return '50%'
  }

  if (isMobile) {
    for (let i = 0; i < 2; i++) {
      list.push(
        customRow ? (
          <Fragment key={i}>{customRow}</Fragment>
        ) : (
          <TableRow key={i}>
            {Array.from(Array(columns).keys()).map((num) => (
              <RowCell key={num} align="unset">
                <Skeleton rectangle width={getWidth(num)} height="18px" />
              </RowCell>
            ))}
          </TableRow>
        )
      )
    }
  } else {
    for (let i = 0; i < rows; i++) {
      list.push(
        customRow ? (
          <Fragment key={i}>{customRow}</Fragment>
        ) : (
          <TableRow key={i}>
            {iterationArr.map((num) => (
              <SkeletonCell key={num} />
            ))}
          </TableRow>
        )
      )
    }
  }

  return <>{list}</>
}

export default SkeletonTable
